import { getViewData } from '../modules/view-data';

export default {
    /**
     * Provide the whitelabel data and boolean helper
     *
     * @param {Object} Vue
     */
    install(Vue) {
        const $whitelabel = getViewData('whitelabel');

        Vue.prototype.$whitelabel = $whitelabel;
        Vue.prototype.$isWhitelabel = Boolean($whitelabel);
    },
};
